<template>
  <modal
    id="weekNotice"
    ref="modalv7"
    size="xl"
    dialog-class="followupv7-dialog"
    :content-class="`followupv7-content-wrapper ${
      isCompletionScreen || (!isApplyDiscount && isMainCancellationScreen)
        ? 'cancellation-main'
        : ''
    }`"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div ref="modalParent"></div>
    <div class="followupv7-wrapper tw-flex tw-flex-col">
      <!-- Header: back arrow (left) + WINONA wordmark (centered) -->
      <div
        class="followupv7-header tw-relative tw-flex tw-items-center tw-justify-center"
      >
        <b-button
          v-if="showBackButton"
          size="sm"
          variant="link"
          class="followupv7-back-btn tw-absolute tw-p-0"
          @click="getPreviousFollowUpQuestion"
        >
          <img
            src="@/assets/images/small_back_arrow.svg"
            alt="Back"
            class="followupv7-back-icon"
          >
        </b-button>
        <img
          src="@/assets/images/logo.svg"
          alt="Winona"
          class="followupv7-logo"
        >
      </div>

      <!-- Discount Badge -->
      <div class="tw-min-h-[40px] tw-mt-5 tw-w-full tw-flex tw-justify-center">
        <SnackbarDiscount
          v-if="showDiscountBadge && couponId"
          :code="couponId.replace(/^st_/, '')"
          :status="discountStatus"
          :loading="loadingApplyCoupon"
          :error-message="errorMessage"
        />
      </div>

      <!-- Body: question content centered both axes -->
      <div
        class="followupv7-body tw-grow tw-flex tw-items-center tw-justify-center tw-px-4"
      >
        <div class="followupv7-content">
          <p
            v-if="showHealthQuestionsTitle"
            class="onboarding-title tw-text-center"
          >
            Health Questions
          </p>
          <ContinueScreen
            v-if="followUpType == 'nothing'"
            :question="followup"
            :composite="composite"
            :disabled="buttonDisabled"
            @submitAnswer="answerFollowUpQuestion"
          />
          <WeekTreatment
            v-if="followUpType == 'treatmentform'"
            :body="followup"
            :parent-ref="$refs.modalParent"
            @submitAnswer="answerFollowUpQuestion"
          />
          <WeekSingleV2
            v-if="followUpType == 'single'"
            :question="followup"
            :composite="composite"
            :main-screen-steps="[
              ...mainCancellationScreenSteps,
              ...completionScreenSteps,
            ]"
            :disabled="buttonDisabled"
            :followup-id="followUpID"
            :patientid="patientid"
            @submitAnswer="answerFollowUpQuestion"
            @discount="onDiscount"
            @getAnswer="setFollowUpMessage"
          />
          <TextareaInput
            v-if="followUpType == 'text'"
            :question="followup"
            :composite="composite"
            :disabled="buttonDisabled"
            @submitAnswer="answerFollowUpQuestion"
          />
          <WeekMultiple
            v-if="followUpType == 'array'"
            :body="followup"
            :disabled="buttonDisabled"
            @submitAnswer="answerFollowUpQuestion"
          />
          <WeekSymptoms
            v-if="followUpType == 'symptoms'"
            :key="hasFollowupObject && followup.question"
            :disabled="buttonDisabled"
            :body="followup"
            @submitSymptoms="submitSymptoms"
          />

          <div
            v-if="composite"
            class="tw-mt-6"
          >
            <TextareaInput
              v-if="
                composite &&
                  secondQuestionBody.answertype == 'text' &&
                  followupList[1].requiredifvalue == firstAnswer
              "
              :question="secondQuestionBody"
              :disabled="buttonDisabled"
              composite
              @submitAnswer="answerFollowUpQuestion"
            />
          </div>
        </div>
      </div>

      <!-- Footer: Treatment Review label -->
      <div class="followupv7-footer tw-text-center">
        <p class="followupv7-footer-text tw-mb-0">
          Treatment Review
        </p>
      </div>
    </div>
  </modal>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

import { ChatService } from '@/services/chat.service.js';
import { PatientService } from '@/services/patient.service.js';

import ContinueScreen from '@/components/10week/week-single/v2/ContinueScreen.vue';
import SnackbarDiscount from '@/components/FollowUpDiscountCodeSystem/SnackbarDiscount.vue';
import WeekSingleV2 from '@/components/10week/week-single/v2';
import TextareaInput from '@/components/10week/week-single/v2/TextareaInput.vue';
import WeekMultiple from '@/components/10week/WeekMultiple';
import WeekSymptoms from '@/components/10week/WeekSymptoms';
import WeekTreatment from '@/components/10week/WeekTreatment';

export default {
  components: {
    ContinueScreen,
    WeekSingleV2,
    TextareaInput,
    WeekMultiple,
    WeekSymptoms,
    WeekTreatment,
    SnackbarDiscount,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    patientid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mainCancellationScreenSteps: [
        3.11, 3.21, 3.31, 3.41, 3.51, 3.71, 3.72, 3.81,
      ],
      completionScreenSteps: [12.2, 12.3, 12.4, 12.5],

      followupList: [],
      followUpID: '',
      composite: false,
      firstAnswer: null,
      followUpType: 'treatment',
      followUpAnswers: [],
      secondQuestionBody: {},
      previousFollowUpID: '',

      buttonDisabled: false,

      isApplyDiscount: false,

      // Discount badge state
      showDiscountBadge: false,
      discountStatus: 'pending',
      loadingApplyCoupon: false,
      errorMessage: null,
      followupIdCheck: null,
    };
  },
  computed: {
    isMainCancellationScreen() {
      if (this.followup?.id) {
        return this.mainCancellationScreenSteps.includes(this.followup.id);
      } else {
        return false;
      }
    },
    isCompletionScreen() {
      if (this.followup?.id) {
        return this.completionScreenSteps.includes(this.followup.id);
      } else {
        return false;
      }
    },
    followup() {
      if (this.followupList.length > 0) {
        return this.followupList[0];
      } else {
        return {};
      }
    },
    hasFollowupObject() {
      return !_.isEmpty(this.followup);
    },
    isSpecialScreenStep() {
      const id = this.followup?.id;
      return (
        [
          ...this.mainCancellationScreenSteps,
          ...this.completionScreenSteps,
        ].includes(id) || id === 8
      );
    },
    showBackButton() {
      return (
        this.hasFollowupObject &&
        !this.isSpecialScreenStep &&
        !(this.followup.id === 12 && this.isApplyDiscount)
      );
    },
    showHealthQuestionsTitle() {
      return (
        this.hasFollowupObject &&
        !this.isSpecialScreenStep &&
        this.followup.id !== 1
      );
    },
    couponId() {
      return this.user?.followup_code ?? this.$route?.query?.fud ?? null;
    },
    ...mapGetters({
      user: 'user/getUser',
    }),
  },
  watch: {
    followupList() {
      if (this.followupList.length > 0) {
        if (
          ['symptom', 'sideeffect'].includes(
            this.followupList[0]?.treatmentoption
          )
        ) {
          this.followUpType = 'symptoms';
        } else if (
          ['recommendation', 'methodchange_recommendation'].includes(
            this.followupList[0]?.answerlookup
          )
        ) {
          this.followUpType = 'treatmentform';
        } else {
          this.followUpType = this.followupList[0].answertype;
        }
      }
    },
  },
  methods: {
    async submitSymptoms(selected, otherAnswer) {
      try {
        this.buttonDisabled = true;
        const { data } = await ChatService.answerFollowUpQuestion(
          this.followUpID,
          this.currentFollowupStep,
          {
            answers: [
              {
                questionid: this.currentFollowupStep,
                answer: selected,
                ...(otherAnswer && { others: [otherAnswer] }),
              },
            ],
          }
        );
        if (data.next === -1) {
          await this.handleFollowupComplete();
          return;
        }
        const result = await this.setFollowUpMessage(this.followUpID, data.next);
        if (!result?.ok) {
          await this.handleFollowupComplete();
          return;
        }
        this.currentFollowupStep = data.next;
        this.buttonDisabled = false;
        // this.loadHealthQuestionStep(data.data.onboardingstep);
      } catch (err) {
        this.buttonDisabled = false;
        this.showAlert(err);
      }
    },
    closeModal() {
      this.$refs.modalv7.$children[0].hide();
      this.$emit('hide');
    },
    async applyCoupon() {
      if (!this.followupIdCheck || !this.couponId) return;
      try {
        this.loadingApplyCoupon = true;
        await PatientService.patientApplyCoupon(this.followupIdCheck, { code: this.couponId });
        this.discountStatus = 'success';
      } catch (error) {
        this.errorMessage = error.message;
        this.discountStatus = 'error';
      } finally {
        this.loadingApplyCoupon = false;
      }
    },
    async handleFollowupComplete() {
      if (this.followupIdCheck && this.couponId) {
        await this.applyCoupon();
      }
      this.closeModal();
    },
    async checkDiscountStatus() {
      try {
        // Refresh user data to get latest followup_code
        await this.$store.dispatch('user/getUser');

        const { data } = await PatientService.getPatientFollowUpCheck();
        this.showDiscountBadge = data.followupstatus?.toUpperCase() === 'SENT';
        this.followupIdCheck = data.id;
      } catch (error) {
        console.error('Error checking discount status:', error);
        this.showDiscountBadge = false;
      }
    },
    async setFollowUpMessage(messageid, step = 1) {
      this.composite = false;
      this.followUpID = messageid;
      try {
        this.secondQuestionBody = {};
        this.buttonDisabled = true;

        // Check discount status when loading follow-up
        await this.checkDiscountStatus();

        const followup = await ChatService.getFollowUpQuestion(messageid, step);
        this.buttonDisabled = false;

        // Answer followupquestion if recommendation engine has an empty answerlist
        if (
          ['recommendation', 'methodchange_recommendation'].includes(
            followup.data?.[0]?.answerlookup
          ) &&
          followup.data?.[0]?.answerlist.length === 0
        ) {
          this.answerFollowUpQuestion({
            id: followup.data?.[0]?.id,
            answer: [],
            answerBody: followup.data?.[0],
          });
          return { ok: true };
        }

        if (Array.isArray(followup.data) && followup.data.length > 0) {
          const fmessage = this.messages.find(x => x.id === messageid);
          this.followupList = followup.data;
          this.followupList.actionstatus = fmessage.actionstatus;
          return { ok: true };
        }

        return {
          ok: false,
          message: typeof followup.data === 'string' ? followup.data : null,
        };
      } catch (e) {
        console.error(e);
        this.buttonDisabled = false;
        return {
          ok: false,
          message: e.message || null,
        };
      }
    },
    async answerFollowUpQuestion({
      id,
      answer,
      answerBody = null,
      others = null,
      text = null,
    } = {}) {
      try {
        const messageid = this.followUpID;

        // * Previous answer overwriting
        this.followUpAnswers = this.followUpAnswers.filter(o => {
          return o.questionid !== id;
        });
        if (id === this.followup?.id) {
          this.firstAnswer = answer;
        }

        if (
          Boolean(answerBody) &&
          answerBody.hasOwnProperty('inline') &&
          answerBody.inline
        ) {
          this.followUpAnswers = [];
          this.composite = true;
          this.previousFollowUpID = id;
          const CompositeFollowUpRequest =
            await ChatService.getFollowUpQuestion(messageid, answerBody.next);
          this.secondQuestionBody = CompositeFollowUpRequest.data[0];
          this.followUpAnswers.push({ questionid: id, answer: answer });
        } else {
          this.followUpAnswers.push({
            questionid: id,
            answer: answer,
            ...(text && { text }),
            ...(others && { others: [others] }),
          });

          // Check for composite answers
          const baseId =
            this.followUpAnswers.length > 1 ? this.previousFollowUpID : id;
          this.buttonDisabled = true;

          const res = await ChatService.answerFollowUpQuestion(
            messageid,
            baseId,
            {
              answers: this.followUpAnswers,
            }
          );

          this.followUpAnswers = [];
          if (res.data.next === -1) {
            await this.handleFollowupComplete();

            return;
          } else {
            // v7: Do NOT auto-answer the treatment-continuation question (id 11).
            // The patient is now shown that question directly so they can pick
            // Yes / No / I'm Not Sure (with optional context for "I'm Not Sure").
            await this.setFollowUpMessage(this.followUpID, res.data.next);
            this.currentFollowupStep = res.data.next;
            this.buttonDisabled = false;
          }
        }
      } catch (error) {
        this.buttonDisabled = false;
        console.log(error);
      }
    },
    async getPreviousFollowUpQuestion() {
      if (this.followup?.id == 1) {
        this.closeModal();
      } else {
        this.composite = false;
        this.followUpAnswers = [];
        this.secondQuestionBody = {};
        const res = await ChatService.getPreviousFollowUpQuestion(
          this.followUpID,
          this.followup?.id
        );
        if (res.data.length > 0) {
          this.currentFollowupStep = res.data[0].id;
        }
        if (res.data) {
          this.followupList = res.data;
          if (res.data.length > 1) {
            this.composite = true;
            this.firstAnswer = res.data[0].answer;
            this.secondQuestionBody = res.data[1];
          }
        }
      }
    },
    onDiscount(val) {
      this.isApplyDiscount = val;
    },
  },
};
</script>

<style lang="scss">
.followupv7-dialog {
  max-width: 960px;

  @include media-breakpoint-down(md) {
    margin: 1rem;
    max-width: calc(100% - 2rem);
  }
}

.followupv7-content-wrapper {
  border-radius: 8px;
  border: 0;
  overflow: hidden;
  min-height: 85vh;

  @include media-breakpoint-down(sm) {
    min-height: calc(100vh - 2rem);
  }
}
</style>

<style lang="scss" scoped>
.followupv7-wrapper {
  min-height: 85vh;
  height: 100%;
  background-color: #ffffff;

  @include media-breakpoint-down(sm) {
    min-height: calc(100vh - 2rem);
  }
}

.followupv7-header {
  height: 72px;
  padding: 0 1.5rem;
  flex-shrink: 0;

  @include media-breakpoint-down(sm) {
    height: 60px;
    padding: 0 1rem;
  }
}

.followupv7-back-btn {
  left: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;

  &:focus {
    box-shadow: none;
  }

  @include media-breakpoint-down(sm) {
    left: 1rem;
  }
}

.followupv7-back-icon {
  height: 18px;
  width: auto;
}

.followupv7-logo {
  height: 18px;
  width: auto;

  @include media-breakpoint-down(sm) {
    height: 16px;
  }
}

.followupv7-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.followupv7-content {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.followupv7-footer {
  padding: 1.5rem 1rem 2rem;
  flex-shrink: 0;
}

.followupv7-footer-text {
  font-size: 0.875rem;
  color: #2c2660;
  font-weight: 600;
  letter-spacing: 0.05rem;
}
</style>
